"use client"

import React from "react";
import Link from "next/link";

import * as gtag from '@/app/lib/helpers/ga';
import {buttonVariants} from "@/app/components/ui/buttons/button";
import {cn} from "@/utils/utils";

// Define a type for the props
interface LinkWithGaTrackingProps {
    href: string | null;
    target?: string;
    variant?: "default" | "homepage" | "homepageSimple";
    size?: "sm" | "homepage-cta" | "xl";
    className?: string;
    linkText: string;
    labelLocation: string;
}

const LinkWithGaTracking: React.FC<LinkWithGaTrackingProps> = ({
                                                                   href,
                                                                   target,
                                                                   variant,
                                                                   size,
                                                                   className,
                                                                   linkText,
                                                                   labelLocation,
                                                               }) => {
    const onClickHandlerWithTracking = (e: React.MouseEvent, label: string) => {
        gtag.event({
            clientWindow: window,
            action: 'request_access',
            category: 'User',
            label: label,
            value: label,
        });
    };

    if (href !== null) {
        return (
            <Link
                href={href}
                prefetch={false}
                target={target}
                className={cn(buttonVariants({variant, size, className}))}
                onClick={(e) => onClickHandlerWithTracking(e, labelLocation)}
            >
                {linkText}
            </Link>
        );
    } else {
        return <></>;
    }
};

export default LinkWithGaTracking;
